import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LoginComponent } from './auth/login/login.component';
import { CrmLayoutComponent } from './modules/crm/crm-layout/crm-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'crm',
    component: CrmLayoutComponent,
    canActivate: [MsalGuard],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
